import type { EnumUnion } from "@dresscode-frontend/utility-types";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { Spacer, VStack } from "@/components/Layout";
import { WorkerType } from "@/constants/workerType";

import AddPersonGatePrimaryProcedure from "./-components/AddPersonGatePrimaryProcedure";
import AddPersonGateProcedures from "./-components/AddPersonGateProcedures";
import StepperHeader from "./-components/StepperHeader";

export const Route = createFileRoute("/_staff/person/add/")({
  component: Introduce,
});

function Introduce() {
  const [selectedWorkerType, setSelectedWorkerType] = useState<
    EnumUnion<typeof WorkerType>
  >(WorkerType.EMPLOYEE);

  return (
    <VStack className="mx-auto w-[1000px]">
      <StepperHeader />
      <Spacer variant="xl" />
      <AddPersonGatePrimaryProcedure
        selectedWorkerType={selectedWorkerType}
        setSelectedWorkerType={setSelectedWorkerType}
      />
      <Spacer variant="m" />
      <AddPersonGateProcedures
        selectedWorkerType={selectedWorkerType}
        setSelectedWorkerType={setSelectedWorkerType}
      />
    </VStack>
  );
}
